import React, { useState, useEffect } from 'react';
import axios from 'axios';

function Whatsapp() {
  const [seccion, setSeccion] = useState('pedidos');
  const [grupos, setGrupos] = useState([]);
  const [gruposDisponibles, setGruposDisponibles] = useState([]);
  const [gruposSeleccionados, setGruposSeleccionados] = useState([]);
  const [planesCompra, setPlanesCompra] = useState([]);
  const [planSeleccionadoWpp, setPlanSeleccionadoWpp] = useState('');
  const [horaPedidos, setHoraPedidos] = useState('07:00');
  const [mensajePedido, setMensajePedido] = useState('Buen día, me pasás la compra por favor? Gracias 😊');
  const [historialFletes, setHistorialFletes] = useState([]);
  const [mensaje, setMensaje] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [programados, setProgramados] = useState([]);
  const [cargandoDisponibles, setCargandoDisponibles] = useState(false);
  const [nuevoGrupo, setNuevoGrupo] = useState('');
  const [nuevoTipo, setNuevoTipo] = useState('proveedor');
  const [editandoGrupo, setEditandoGrupo] = useState(null);
  const [listaProveedoresWpp, setListaProveedoresWpp] = useState([]);
  const [estadoWPP, setEstadoWPP] = useState(false);
  const [iniciandoWPP, setIniciandoWPP] = useState(false);
  const [qrImagen, setQrImagen] = useState(null);

  const token = localStorage.getItem('token');

  const cargarGrupos = async () => {
    try {
      const res = await axios.get('https://comprasmercadomodelo.online/api/whatsapp/grupos', {
        headers: { authorization: token }
      });
      setGrupos(res.data);
    } catch (err) { console.error(err); }
  };

  const cargarListaProveedoresWpp = async () => {
    try {
      const res = await axios.get("https://comprasmercadomodelo.online/api/admin/proveedores", { headers: { authorization: token } });
      setListaProveedoresWpp(res.data);
    } catch (err) { console.error(err); }
  };

  const cargarPlanesCompra = async () => {
    try {
      const res = await axios.get("https://comprasmercadomodelo.online/api/planes", { headers: { authorization: token } });
      setPlanesCompra(res.data);
    } catch (err) { console.error(err); }
  };

  const seleccionarPlanWpp = async (planId) => {
    setPlanSeleccionadoWpp(planId);
    if (!planId) { setGruposSeleccionados([]); return; }
    try {
      const url = "https://comprasmercadomodelo.online/api/whatsapp/planes/" + planId + "/proveedores-cargados";
      const res = await axios.get(url, { headers: { authorization: token } });
      const idsProveedoresConCarga = res.data;
      const coinciden = gruposProveedores.filter(g => g.proveedor_id && idsProveedoresConCarga.includes(g.proveedor_id)).map(g => g.nombre);
      setGruposSeleccionados(coinciden);
    } catch (err) { console.error(err); }
  };

  const cargarHistorialFletes = async () => {
    try {
      const res = await axios.get('https://comprasmercadomodelo.online/api/whatsapp/fletes/historial', {
        headers: { authorization: token }
      });
      setHistorialFletes(res.data);
    } catch (err) { console.error(err); }
  };

  const cargarProgramados = async () => {
    try {
      const res = await axios.get('https://comprasmercadomodelo.online/api/whatsapp/pedidos/programados', {
        headers: { authorization: token }
      });
      setProgramados(res.data);
    } catch (err) { console.error(err); }
  };

  const verificarEstadoWPP = async () => {
    try {
      const res = await axios.get('https://comprasmercadomodelo.online/api/whatsapp/estado', {
        headers: { authorization: token }
      });
      setEstadoWPP(res.data.conectado);
      setQrImagen(res.data.qr || null);
    } catch (err) { console.error(err); }
  };

  const iniciarWhatsApp = async () => {
    setIniciandoWPP(true);
    setMensaje('⏳ Iniciando WhatsApp... esperá el QR abajo');
    try {
      await axios.post('https://comprasmercadomodelo.online/api/whatsapp/iniciar', {}, {
        headers: { authorization: token }
      });
      const interval = setInterval(async () => {
        try {
          const res = await axios.get('https://comprasmercadomodelo.online/api/whatsapp/estado', {
            headers: { authorization: token }
          });
          setQrImagen(res.data.qr || null);
          if (res.data.conectado) {
            setEstadoWPP(true);
            setQrImagen(null);
            setMensaje('✅ WhatsApp conectado correctamente');
            setIniciandoWPP(false);
            clearInterval(interval);
          }
        } catch (e) {}
      }, 3000);
      setTimeout(() => {
        clearInterval(interval);
        setIniciandoWPP(false);
      }, 120000);
    } catch (err) {
      setMensaje('❌ Error al iniciar WhatsApp');
      setIniciandoWPP(false);
    }
  };

  const cargarGruposDisponibles = async () => {
    setCargandoDisponibles(true);
    try {
      const res = await axios.get('https://comprasmercadomodelo.online/api/whatsapp/grupos/disponibles', {
        headers: { authorization: token }
      });
      setGruposDisponibles(res.data);
      setMensaje(`✅ ${res.data.length} grupos encontrados en WhatsApp`);
    } catch (err) {
      setMensaje('❌ Error al cargar grupos — ¿WhatsApp está conectado?');
    }
    setCargandoDisponibles(false);
  };

  const agregarGrupoDesdeWPP = async (nombre) => {
    try {
      await axios.post('https://comprasmercadomodelo.online/api/whatsapp/grupos',
        { nombre, tipo: nuevoTipo },
        { headers: { authorization: token } }
      );
      cargarGrupos();
      setMensaje(`✅ Grupo "${nombre}" agregado`);
    } catch (err) {
      setMensaje('❌ Error al agregar grupo');
    }
  };

  useEffect(() => {
    cargarGrupos();
    cargarListaProveedoresWpp();
    cargarPlanesCompra();
    cargarHistorialFletes();
    cargarProgramados();
    verificarEstadoWPP();
    const interval = setInterval(verificarEstadoWPP, 10000);
    return () => clearInterval(interval);
  }, []);

  const agregarGrupo = async () => {
    if (!nuevoGrupo.trim()) return;
    try {
      await axios.post('https://comprasmercadomodelo.online/api/whatsapp/grupos',
        { nombre: nuevoGrupo.trim(), tipo: nuevoTipo },
        { headers: { authorization: token } }
      );
      setNuevoGrupo('');
      setNuevoTipo('proveedor');
      cargarGrupos();
      setMensaje('✅ Grupo agregado correctamente');
    } catch (err) {
      setMensaje('❌ Error al agregar grupo');
    }
  };

  const eliminarGrupo = async (id) => {
    if (!window.confirm('¿Eliminar este grupo?')) return;
    try {
      await axios.delete(`https://comprasmercadomodelo.online/api/whatsapp/grupos/${id}`, {
        headers: { authorization: token }
      });
      cargarGrupos();
      setMensaje('✅ Grupo eliminado');
    } catch (err) {
      setMensaje('❌ Error al eliminar');
    }
  };

  const guardarEdicion = async (id) => {
    try {
      await axios.put(`https://comprasmercadomodelo.online/api/whatsapp/grupos/${id}`,
        editandoGrupo,
        { headers: { authorization: token } }
      );
      setEditandoGrupo(null);
      cargarGrupos();
      setMensaje('✅ Grupo actualizado');
    } catch (err) {
      setMensaje('❌ Error al actualizar');
    }
  };

  const toggleGrupo = (nombre) => {
    setGruposSeleccionados(prev =>
      prev.includes(nombre) ? prev.filter(g => g !== nombre) : [...prev, nombre]
    );
  };

  const enviarAhora = async () => {
    if (gruposSeleccionados.length === 0) { setMensaje('❌ Seleccioná al menos un grupo'); return; }
    setEnviando(true);
    try {
      const res = await axios.post('https://comprasmercadomodelo.online/api/whatsapp/grupos/enviar',
        { grupos: gruposSeleccionados, mensaje: mensajePedido },
        { headers: { authorization: token } }
      );
      setMensaje(`✅ Enviado a ${res.data.enviados} grupos${res.data.errores.length > 0 ? ` — ❌ Error en: ${res.data.errores.join(', ')}` : ''}`);
      setGruposSeleccionados([]);
    } catch (err) { setMensaje('❌ Error al enviar'); }
    setEnviando(false);
  };

  const programarPedidos = async () => {
    if (gruposSeleccionados.length === 0) { setMensaje('❌ Seleccioná al menos un grupo'); return; }
    try {
      await axios.post('https://comprasmercadomodelo.online/api/whatsapp/pedidos/programar',
        { grupos: gruposSeleccionados, hora: horaPedidos, mensaje: mensajePedido },
        { headers: { authorization: token } }
      );
      setMensaje(`✅ Programado para ${gruposSeleccionados.length} grupos a las ${horaPedidos}`);
      setGruposSeleccionados([]);
      cargarProgramados();
    } catch (err) { setMensaje('❌ Error al programar'); }
  };

  const verificarFletes = async () => {
    try {
      await axios.post('https://comprasmercadomodelo.online/api/whatsapp/fletes/verificar', {},
        { headers: { authorization: token } }
      );
      setMensaje('✅ Verificación ejecutada');
      cargarHistorialFletes();
    } catch (err) { setMensaje('❌ Error al verificar'); }
  };

  const gruposProveedores = grupos.filter(g => g.tipo === 'proveedor' && g.activo);
  const gruposFletes = grupos.filter(g => g.tipo === 'flete' && g.activo);
  const gruposYaAgregados = grupos.map(g => g.nombre);

  return (
    <div style={styles.container}>
      <h3 style={styles.titulo}>📱 WhatsApp</h3>

      {/* Barra de estado */}
      <div style={{ ...styles.estadoWPPBar, backgroundColor: estadoWPP ? '#eafaf1' : '#fdf2f2', borderColor: estadoWPP ? '#27ae60' : '#e74c3c' }}>
        <span style={{ color: estadoWPP ? '#27ae60' : '#e74c3c', fontWeight: 'bold', fontSize: '14px' }}>
          {estadoWPP ? '✅ WhatsApp conectado' : '❌ WhatsApp desconectado'}
        </span>
        {!estadoWPP && (
          <button style={styles.botonConectarWPP} onClick={iniciarWhatsApp} disabled={iniciandoWPP}>
            {iniciandoWPP ? '⏳ Conectando...' : '📱 Conectar WhatsApp'}
          </button>
        )}
      </div>

      {/* QR en pantalla */}
      {!estadoWPP && iniciandoWPP && !qrImagen && (
        <div style={styles.qrContainer}>
          <p style={styles.qrTexto}>⏳ Iniciando WhatsApp... el QR aparecerá en unos segundos</p>
        </div>
      )}
      {!estadoWPP && qrImagen && (
        <div style={styles.qrContainer}>
          <p style={styles.qrTexto}>📱 Escaneá este QR con WhatsApp del mercado:</p>
          <img src={qrImagen} alt="QR WhatsApp" style={styles.qrImagen} />
          <p style={styles.qrAyuda}>Abrí WhatsApp → Dispositivos vinculados → Vincular dispositivo</p>
        </div>
      )}

      {mensaje && (
        <div style={styles.mensajeBox}>
          {mensaje}
          <button style={styles.cerrarMensaje} onClick={() => setMensaje('')}>✕</button>
        </div>
      )}

      <div style={styles.tabs}>
        <button style={{ ...styles.tab, ...(seccion === 'pedidos' ? styles.tabActivo : {}) }}
          onClick={() => setSeccion('pedidos')}>📋 Pedidos a Proveedores</button>
        <button style={{ ...styles.tab, ...(seccion === 'fletes' ? styles.tabActivo : {}) }}
          onClick={() => setSeccion('fletes')}>🚛 Fletes</button>
        <button style={{ ...styles.tab, ...(seccion === 'grupos' ? styles.tabActivo : {}) }}
          onClick={() => setSeccion('grupos')}>⚙️ Gestionar Grupos</button>
      </div>

      {/* PEDIDOS */}
      {seccion === 'pedidos' && (
        <div>
          <div style={styles.card}>
            <h4 style={styles.cardTitulo}>⚙️ Mensaje a enviar</h4>
            <div style={styles.campo}>
              <label style={styles.label}>Hora de envío programado</label>
              <input style={styles.inputHora} type="time" value={horaPedidos}
                onChange={(e) => setHoraPedidos(e.target.value)} />
            </div>
            <div style={styles.campo}>
              <label style={styles.label}>Mensaje</label>
              <textarea style={styles.textarea} value={mensajePedido}
                onChange={(e) => setMensajePedido(e.target.value)} />
            </div>
          </div>

          <div style={styles.card}>
            <div style={styles.campo}>
              <label style={styles.label}>Plan de compras (preselecciona automatico)</label>
              <select style={styles.input} value={planSeleccionadoWpp} onChange={(e) => seleccionarPlanWpp(e.target.value)}>
                <option value="">-- Sin plan (elegir manual) --</option>
                {planesCompra.map(pl => (
                  <option key={pl.id} value={pl.id}>{pl.fecha} (Plan {pl.id})</option>
                ))}
              </select>
            </div>
            <h4 style={styles.cardTitulo}>🏪 Seleccioná los grupos de hoy</h4>
            {gruposProveedores.length === 0 ? (
              <div style={styles.sinGrupos}>
                ⚠️ No hay grupos de proveedores cargados.
                <button style={styles.botonIrGrupos} onClick={() => setSeccion('grupos')}>→ Ir a Gestionar Grupos</button>
              </div>
            ) : (
              <>
                {gruposSeleccionados.length > 0 && (
                  <div style={styles.seleccionados}>
                    <span style={styles.selCount}>✅ {gruposSeleccionados.length} grupo(s) seleccionado(s)</span>
                    <button style={styles.botonLimpiar} onClick={() => setGruposSeleccionados([])}>✕ Limpiar</button>
                  </div>
                )}
                <div style={styles.listaGrupos}>
                  {gruposProveedores.map(g => {
                    const sel = gruposSeleccionados.includes(g.nombre);
                    return (
                      <div key={g.id}
                        style={{ ...styles.itemGrupo, backgroundColor: sel ? '#eafaf1' : 'white', border: sel ? '2px solid #27ae60' : '1px solid #ecf0f1' }}
                        onClick={() => toggleGrupo(g.nombre)}>
                        <span style={styles.nombreGrupo}>{g.nombre}</span>
                        {g.proveedor_id && <span style={{ fontSize: "11px", color: "#7f8c8d" }}> ({(listaProveedoresWpp.find(pv => pv.id === g.proveedor_id) || {}).nombre})</span>}
                        {sel && <span>✅</span>}
                      </div>
                    );
                  })}
                </div>
                <div style={styles.botones}>
                  <button style={styles.botonEnviarAhora} onClick={enviarAhora} disabled={enviando}>
                    {enviando ? '⏳ Enviando...' : '📤 Enviar ahora'}
                  </button>
                  <button style={styles.botonProgramar} onClick={programarPedidos}>
                    ⏰ Programar para las {horaPedidos}
                  </button>
                </div>
              </>
            )}
          </div>

          {programados.length > 0 && (
            <div style={styles.card}>
              <h4 style={styles.cardTitulo}>⏰ Programados para hoy</h4>
              {programados.map(p => {
                const gs = JSON.parse(p.proveedores || '[]');
                return (
                  <div key={p.id} style={styles.itemProgramado}>
                    <span style={styles.horaProg}>🕐 {p.hora_envio}</span>
                    <span>{p.estado === 'enviado' ? '✅ Enviado' : p.estado === 'error' ? '❌ Error' : '⏳ Pendiente'}</span>
                    <span style={styles.provsProg}>{gs.join(', ')}</span>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}

      {/* FLETES */}
      {seccion === 'fletes' && (
        <div>
          <div style={styles.card}>
            <h4 style={styles.cardTitulo}>🚛 Recordatorio automático de fletes</h4>
            <p style={styles.infoFlete}>
              El sistema envía automáticamente al grupo de fletes el recordatorio de pago al día siguiente de cada compra con flete.
            </p>
            {gruposFletes.length > 0 ? (
              <p style={styles.infoFlete}>✅ Grupo configurado: <strong>{gruposFletes.map(g => g.nombre).join(', ')}</strong></p>
            ) : (
              <p style={{ color: '#e74c3c', fontSize: '14px' }}>
                ⚠️ No hay grupo de fletes configurado.
                <button style={styles.botonIrGrupos} onClick={() => setSeccion('grupos')}>→ Agregar grupo</button>
              </p>
            )}
            <button style={styles.botonVerificar} onClick={verificarFletes}>
              🔍 Verificar fletes pendientes ahora
            </button>
          </div>

          <div style={styles.card}>
            <h4 style={styles.cardTitulo}>📋 Historial de fletes enviados</h4>
            {historialFletes.length === 0 ? (
              <p style={styles.sinDatos}>No hay fletes registrados todavía</p>
            ) : (
              <table style={styles.tabla}>
                <thead>
                  <tr style={styles.thead}>
                    <th style={styles.th}>Fecha compra</th>
                    <th style={styles.th}>Tipo</th>
                    <th style={styles.th}>Flete tercero $</th>
                    <th style={styles.th}>Flete propio $</th>
                    <th style={styles.th}>Comentario</th>
                    <th style={styles.th}>Enviado</th>
                  </tr>
                </thead>
                <tbody>
                  {historialFletes.map(f => (
                    <tr key={f.id} style={styles.tr}>
                      <td style={styles.td}>{new Date(f.fecha_compra).toLocaleDateString('es-AR')}</td>
                      <td style={styles.td}>{f.flete_tipo}</td>
                      <td style={styles.td}>{f.flete_importe > 0 ? `$${Number(f.flete_importe).toLocaleString('es-AR')}` : '-'}</td>
                      <td style={styles.td}>{f.flete_propio_importe > 0 ? `$${Number(f.flete_propio_importe).toLocaleString('es-AR')}` : '-'}</td>
                      <td style={styles.td}>{f.comentario || '-'}</td>
                      <td style={styles.td}>{f.enviado_en ? new Date(f.enviado_en).toLocaleString('es-AR') : '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}

      {/* GESTIONAR GRUPOS */}
      {seccion === 'grupos' && (
        <div>
          <div style={styles.card}>
            <h4 style={styles.cardTitulo}>📲 Cargar grupos desde WhatsApp</h4>
            <p style={styles.ayuda}>Hacé clic para ver todos los grupos donde está el número del mercado y agregarlos con un clic.</p>
            <button style={styles.botonCargarWPP} onClick={cargarGruposDisponibles} disabled={cargandoDisponibles}>
              {cargandoDisponibles ? '⏳ Cargando...' : '📲 Ver grupos de WhatsApp'}
            </button>
            {gruposDisponibles.length > 0 && (
              <div style={{ marginTop: '15px' }}>
                <div style={styles.filtroTipoDisp}>
                  <label style={styles.label}>Tipo para los que agregues:</label>
                  <select style={styles.selectTipo} value={nuevoTipo} onChange={(e) => setNuevoTipo(e.target.value)}>
                    <option value="proveedor">Proveedor</option>
                    <option value="flete">Flete</option>
                    <option value="otro">Otro</option>
                  </select>
                </div>
                <div style={styles.listaDisponibles}>
                  {gruposDisponibles.map(g => {
                    const yaAgregado = gruposYaAgregados.includes(g.nombre);
                    return (
                      <div key={g.id} style={styles.itemDisponible}>
                        <span style={styles.nombreGrupoDisp}>{g.nombre}</span>
                        {yaAgregado ? (
                          <span style={styles.yaAgregado}>✅ Ya agregado</span>
                        ) : (
                          <button style={styles.botonAgregarWPP} onClick={() => agregarGrupoDesdeWPP(g.nombre)}>
                            + Agregar
                          </button>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>

          <div style={styles.card}>
            <h4 style={styles.cardTitulo}>✏️ Agregar grupo manualmente</h4>
            <div style={styles.filaAgregar}>
              <input style={styles.inputGrupo} type="text"
                placeholder="Nombre exacto del grupo en WhatsApp"
                value={nuevoGrupo}
                onChange={(e) => setNuevoGrupo(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && agregarGrupo()} />
              <select style={styles.selectTipo} value={nuevoTipo} onChange={(e) => setNuevoTipo(e.target.value)}>
                <option value="proveedor">Proveedor</option>
                <option value="flete">Flete</option>
                <option value="otro">Otro</option>
              </select>
              <button style={styles.botonAgregar} onClick={agregarGrupo}>+ Agregar</button>
            </div>
          </div>

          <div style={styles.card}>
            <h4 style={styles.cardTitulo}>📋 Grupos configurados ({grupos.length})</h4>
            {grupos.length === 0 ? (
              <p style={styles.sinDatos}>No hay grupos configurados todavía</p>
            ) : (
              <table style={styles.tabla}>
                <thead>
                  <tr style={styles.thead}>
                    <th style={styles.th}>Nombre del grupo</th>
                    <th style={styles.th}>Tipo</th>
                    <th style={styles.th}>Proveedor vinculado</th>
                    <th style={styles.th}>Estado</th>
                    <th style={styles.th}>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {grupos.map(g => (
                    <tr key={g.id} style={styles.tr}>
                      <td style={styles.td}>
                        {editandoGrupo?.id === g.id ? (
                          <input style={styles.inputEditar} value={editandoGrupo.nombre}
                            onChange={(e) => setEditandoGrupo({ ...editandoGrupo, nombre: e.target.value })} />
                        ) : g.nombre}
                      </td>
                      <td style={styles.td}>
                        {editandoGrupo?.id === g.id ? (
                          <select style={styles.selectEditar} value={editandoGrupo.tipo}
                            onChange={(e) => setEditandoGrupo({ ...editandoGrupo, tipo: e.target.value })}>
                            <option value="proveedor">Proveedor</option>
                            <option value="flete">Flete</option>
                            <option value="otro">Otro</option>
                          </select>
                        ) : (
                          <span style={{ ...styles.tipoBadge, backgroundColor: g.tipo === 'flete' ? '#e74c3c' : g.tipo === 'proveedor' ? '#27ae60' : '#95a5a6' }}>
                            {g.tipo}
                          </span>
                        )}
                      </td>
                      <td style={styles.td}>
                        {editandoGrupo?.id === g.id ? (
                          <select style={styles.selectEditar} value={editandoGrupo.proveedor_id || ""}
                            onChange={(e) => setEditandoGrupo({ ...editandoGrupo, proveedor_id: e.target.value || null })}>
                            <option value="">-- Sin vincular --</option>
                            {listaProveedoresWpp.map(pv => (
                              <option key={pv.id} value={pv.id}>{pv.nombre}</option>
                            ))}
                          </select>
                        ) : (
                          g.proveedor_id ? (
                            <span style={styles.tipoBadge}>{(listaProveedoresWpp.find(pv => pv.id === g.proveedor_id) || {}).nombre || "ID " + g.proveedor_id}</span>
                          ) : <span style={{ color: "#e67e22" }}>Sin vincular</span>
                        )}
                      </td>
                      <td style={styles.td}>
                        <span style={{ color: g.activo ? '#27ae60' : '#e74c3c' }}>
                          {g.activo ? '✅ Activo' : '❌ Inactivo'}
                        </span>
                      </td>
                      <td style={styles.td}>
                        {editandoGrupo?.id === g.id ? (
                          <div style={{ display: 'flex', gap: '5px' }}>
                            <button style={styles.botonGuardarPeq} onClick={() => guardarEdicion(g.id)}>✓</button>
                            <button style={styles.botonCancelarPeq} onClick={() => setEditandoGrupo(null)}>✕</button>
                          </div>
                        ) : (
                          <div style={{ display: 'flex', gap: '5px' }}>
                            <button style={styles.botonEditar} onClick={() => setEditandoGrupo({ id: g.id, nombre: g.nombre, tipo: g.tipo, activo: g.activo, proveedor_id: g.proveedor_id })}>✏️</button>
                            <button style={styles.botonEliminar} onClick={() => eliminarGrupo(g.id)}>🗑️</button>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  container: { padding: '20px' },
  titulo: { color: '#2c3e50', fontSize: '22px', marginBottom: '15px' },
  estadoWPPBar: { padding: '12px 20px', borderRadius: '8px', marginBottom: '15px', border: '1px solid', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  botonConectarWPP: { backgroundColor: '#25d366', color: 'white', border: 'none', padding: '8px 20px', borderRadius: '6px', cursor: 'pointer', fontSize: '14px' },
  qrContainer: { backgroundColor: 'white', padding: '25px', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', marginBottom: '20px', textAlign: 'center' },
  qrTexto: { color: '#2c3e50', fontSize: '16px', marginBottom: '15px', fontWeight: 'bold' },
  qrImagen: { width: '250px', height: '250px', border: '3px solid #25d366', borderRadius: '10px' },
  qrAyuda: { color: '#7f8c8d', fontSize: '13px', marginTop: '15px' },
  mensajeBox: { backgroundColor: '#ffeaa7', padding: '15px 20px', borderRadius: '8px', marginBottom: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '14px' },
  cerrarMensaje: { background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px' },
  tabs: { display: 'flex', gap: '5px', marginBottom: '20px', flexWrap: 'wrap' },
  tab: { padding: '10px 20px', borderRadius: '6px', border: '1px solid #ddd', backgroundColor: 'white', cursor: 'pointer', fontSize: '14px' },
  tabActivo: { backgroundColor: '#25d366', color: 'white', border: '1px solid #25d366' },
  card: { backgroundColor: 'white', padding: '25px', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', marginBottom: '20px' },
  cardTitulo: { color: '#2c3e50', fontSize: '16px', marginBottom: '15px' },
  campo: { display: 'flex', flexDirection: 'column', gap: '5px', marginBottom: '15px' },
  label: { fontSize: '13px', color: '#7f8c8d' },
  inputHora: { padding: '10px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '14px', width: '150px' },
  textarea: { padding: '10px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '14px', minHeight: '80px', width: '100%', maxWidth: '500px' },
  sinGrupos: { color: '#e67e22', fontSize: '14px', display: 'flex', alignItems: 'center', gap: '15px' },
  botonIrGrupos: { backgroundColor: '#2980b9', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' },
  seleccionados: { backgroundColor: '#eafaf1', padding: '10px 15px', borderRadius: '6px', marginBottom: '15px', display: 'flex', gap: '15px', alignItems: 'center' },
  selCount: { color: '#27ae60', fontWeight: 'bold', fontSize: '13px' },
  botonLimpiar: { padding: '5px 10px', borderRadius: '4px', border: '1px solid #ddd', backgroundColor: 'white', cursor: 'pointer', color: '#e74c3c', fontSize: '12px' },
  listaGrupos: { display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '20px' },
  itemGrupo: { padding: '10px 20px', borderRadius: '25px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', color: '#2c3e50' },
  nombreGrupo: { fontWeight: '500' },
  botones: { display: 'flex', gap: '10px', flexWrap: 'wrap' },
  botonEnviarAhora: { backgroundColor: '#25d366', color: 'white', border: 'none', padding: '12px 25px', borderRadius: '6px', cursor: 'pointer', fontSize: '14px' },
  botonProgramar: { backgroundColor: '#2980b9', color: 'white', border: 'none', padding: '12px 25px', borderRadius: '6px', cursor: 'pointer', fontSize: '14px' },
  itemProgramado: { display: 'flex', gap: '15px', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid #ecf0f1', flexWrap: 'wrap' },
  horaProg: { fontWeight: 'bold', color: '#2c3e50' },
  provsProg: { color: '#7f8c8d', fontSize: '13px' },
  infoFlete: { color: '#2c3e50', fontSize: '14px', marginBottom: '15px', lineHeight: '1.6' },
  botonVerificar: { backgroundColor: '#9b59b6', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '6px', cursor: 'pointer', fontSize: '14px' },
  botonCargarWPP: { backgroundColor: '#25d366', color: 'white', border: 'none', padding: '12px 25px', borderRadius: '6px', cursor: 'pointer', fontSize: '14px' },
  filtroTipoDisp: { display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' },
  listaDisponibles: { maxHeight: '300px', overflowY: 'auto', border: '1px solid #ecf0f1', borderRadius: '8px' },
  itemDisponible: { padding: '10px 15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #f8f9fa' },
  nombreGrupoDisp: { fontSize: '14px', color: '#2c3e50' },
  yaAgregado: { fontSize: '13px', color: '#27ae60' },
  botonAgregarWPP: { backgroundColor: '#27ae60', color: 'white', border: 'none', padding: '5px 12px', borderRadius: '4px', cursor: 'pointer', fontSize: '13px' },
  filaAgregar: { display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' },
  inputGrupo: { padding: '10px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '14px', flex: 1, minWidth: '250px' },
  selectTipo: { padding: '10px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '14px' },
  botonAgregar: { backgroundColor: '#27ae60', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '6px', cursor: 'pointer', fontSize: '14px' },
  ayuda: { fontSize: '13px', color: '#7f8c8d', marginBottom: '15px' },
  sinDatos: { textAlign: 'center', color: '#95a5a6', padding: '30px' },
  tabla: { width: '100%', borderCollapse: 'collapse' },
  thead: { backgroundColor: '#2c3e50' },
  th: { color: 'white', padding: '10px 15px', textAlign: 'left', fontSize: '12px' },
  tr: { borderBottom: '1px solid #ecf0f1' },
  td: { padding: '10px 15px', fontSize: '13px', color: '#2c3e50' },
  tipoBadge: { color: 'white', padding: '3px 10px', borderRadius: '20px', fontSize: '12px' },
  inputEditar: { padding: '6px', borderRadius: '4px', border: '1px solid #ddd', fontSize: '13px', width: '200px' },
  selectEditar: { padding: '6px', borderRadius: '4px', border: '1px solid #ddd', fontSize: '13px' },
  botonEditar: { backgroundColor: '#f0f0f0', border: '1px solid #ddd', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer' },
  botonEliminar: { backgroundColor: '#fdf2f2', border: '1px solid #e74c3c', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer' },
  botonGuardarPeq: { backgroundColor: '#27ae60', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer' },
  botonCancelarPeq: { backgroundColor: '#e74c3c', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer' }
};

export default Whatsapp;
